import { format, parse } from 'date-fns';
import { DayOfWeekEnum } from 'types/generated/client';
import { dayOfWeekPluralLabel, dayOfWeekShortLabel } from 'utils/shared/dayOfWeek';
import { Weekday } from './types';

/** Sunday-first, matching `Date#getDay()`. */
export const WEEKDAY_INDEX: Record<Weekday, number> = {
  [Weekday.Sun]: 0,
  [Weekday.Mon]: 1,
  [Weekday.Tue]: 2,
  [Weekday.Wed]: 3,
  [Weekday.Thu]: 4,
  [Weekday.Fri]: 5,
  [Weekday.Sat]: 6,
};

/** Slot rows store `Weekday` ("MON"); finder preferences store `DayOfWeekEnum` ("MONDAY"). */
export const WEEKDAY_TO_DAY_OF_WEEK: Record<Weekday, DayOfWeekEnum> = {
  [Weekday.Sun]: DayOfWeekEnum.Sunday,
  [Weekday.Mon]: DayOfWeekEnum.Monday,
  [Weekday.Tue]: DayOfWeekEnum.Tuesday,
  [Weekday.Wed]: DayOfWeekEnum.Wednesday,
  [Weekday.Thu]: DayOfWeekEnum.Thursday,
  [Weekday.Fri]: DayOfWeekEnum.Friday,
  [Weekday.Sat]: DayOfWeekEnum.Saturday,
};

/** "Wed" — labels come from the shared DayOfWeek helpers via the enum mapping. */
export const weekdayShortLabel = (day: Weekday) => dayOfWeekShortLabel(WEEKDAY_TO_DAY_OF_WEEK[day]);

/** "Wednesdays" — the preview's "Available on" pills. */
export const weekdayPluralLabel = (day: Weekday) =>
  dayOfWeekPluralLabel(WEEKDAY_TO_DAY_OF_WEEK[day]);

/** Rendered order + "Sun"-style labels for the availability rows. */
export const WEEKDAYS: { value: Weekday; label: string }[] = Object.values(Weekday).map(
  (value) => ({ value, label: weekdayShortLabel(value) }),
);

/** "18:00" / "18:00:00" → "6 pm", "09:30" → "9:30 am" — the short slot time format. */
export const formatShortTime = (time: string) => {
  const parsed = parse(time.slice(0, 5), 'HH:mm', new Date(2000, 0, 2));
  if (Number.isNaN(parsed.getTime())) return time;
  return format(parsed, parsed.getMinutes() ? 'h:mm aaa' : 'h aaa');
};
